import axios from "axios";

class Transactions {
  static findAll = () => {
    return axios.get("/transactions/").then((resp) => resp.data);
  };
}

export default Transactions;
